module.exports = __webpack_public_path__ + "img/intro.08ade8f0.png";